import { customCompare } from './sorter'
import { FilterItem } from './entities';

const sortByName = (a: FilterItem, b: FilterItem) => customCompare(a.name, b.name);

export default sortByName;